import React, { useCallback, useState } from "react"
import { ChangeLanguageComponent } from "components/shared/ModalHelpers"
import { useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { PublicService } from "services/api-service"
import { SentryService } from "services/SentryService"
import Button from "ui/components/atoms/button"
import Input from "ui/components/atoms/input"
import Alert from "ui/components/molecules/alert"
import Modal from "ui/components/molecules/modal"
import { EMAIL_REGEX } from "ui/utils/regex"

const ForgotPassword = () => {
  const navigate = useNavigate()
  const { t } = useTranslation(["login", "common", "form"])
  const dispatch = useDispatch()
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm()

  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<string | boolean>(false)

  const onSubmit = useCallback(
    async (el: any) => {
      try {
        setLoading(true)
        setResponse(false)
        await PublicService.changePassword(el.username)
        setResponse("success")
        reset()
      } catch (e) {
        SentryService.error("[ERROR UserService.updatePassword]:", e)
        setResponse("error")
      } finally {
        setLoading(false)
      }
    },
    [reset],
  )

  const handleLogin = useCallback(() => {
    navigate("/login")
  }, [navigate])

  return (
    <Modal
      show={true}
      icon="shield"
      title={t("forgot-password-form.title", { ns: "login" })}
      text={t("forgot-password-form.text", { ns: "login" })}
      $maxWidth="400px"
      showBackground={false}
      helperElement={<ChangeLanguageComponent />}
    >
      <>
        {response === "error" && (
          <Alert $type="error" $small $marginBottom="S">
            {t("forgot-password-form.error", { ns: "login" })}
          </Alert>
        )}
        {response === "success" && (
          <Alert $type="success" $small $marginBottom="S">
            {t("forgot-password-form.success", { ns: "login" })}
          </Alert>
        )}
        <Input
          name="username"
          label={`${t("email", { ns: "form" })}*`}
          placeholder="imie.nazwisko@gmail.com"
          error={errors.username}
          rhf={register("username", {
            required: t("required", { ns: "form" }),
            pattern: {
              value: EMAIL_REGEX,
              message: t("wrong-email", { ns: "form" }),
            },
          })}
          $marginBottom="S"
        />
        <Button $width="100%" $marginBottom="XS" loading={loading} onClick={handleSubmit(onSubmit)}>
          {t("reset-password", { ns: "common" })}
        </Button>
        <Button $type="third" $width="100%" onClick={handleLogin}>
          {t("login", { ns: "common" })}
        </Button>
      </>
    </Modal>
  )
}

export default ForgotPassword
